import { LockOutlined } from '@mui/icons-material';
import Typography from '@mui/material/Typography';
import Logo from '../Logo/Logo';
import mastercardIcon from '@/assets/mastercard.png?w=34&h=24&format=webp&imagetools';
import swishIcon from '@/assets/swish.png?w=24&h=24&format=webp&imagetools';
import visaIcon from '@/assets/visa.png?w=48&h=24&format=webp&imagetools';
import bankIdIcon from '@/assets/bankid.png?w=36&h=30&format=webp&imagetools';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';
import Link from '@/components/Link/Link';

const PolicyLogoFooter = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  return (
    <Stack alignItems='center' gap={2}>
      <Link
        fontWeight='bold'
        variant='body3'
        href={currentLanguage === 'sv' ? 'https://akova.se/integritetspolicy' : 'https://akova.se/en/privacy-policy/'}
        target='_blank'
      >
        {t('common-phrases.privacy-policy')}
      </Link>

      <Stack alignItems='center' gap={0.5}>
        <LockOutlined sx={{ fontSize: '1.5rem', verticalAlign: 'middle' }} />
        <Typography variant='body3'>{t('common-phrases.safe-and-secure-at')}</Typography>
        <Logo height='30px' width='100px' type='akova' />
      </Stack>

      <Stack direction='row' alignItems='center' justifyContent='center' gap={1}>
        <img src={swishIcon} alt='Swish' style={{ height: '24px' }} />
        <img src={mastercardIcon} alt='MasterCard' style={{ height: '24px' }} />
        <img src={visaIcon} alt='Visa' style={{ height: '24px' }} />
        <img src={bankIdIcon} alt='BankID' style={{ height: '30px' }} />
      </Stack>
    </Stack>
  );
};

export default PolicyLogoFooter;
